'use client'

import { BASE_DAYS, risingLabel, WEEK } from '@/utils/coverageTrends'

// Date helpers for the topic and storyline pages' periods. The "Coverage"
// section that lived here (2026-10-24) went on 2026-11-01: those pages open
// with the shared CoverageBlock now.

export function addDays(day, n) {
  const d = new Date(`${day}T12:00:00Z`)
  d.setUTCDate(d.getUTCDate() + n)
  return d.toISOString().slice(0, 10)
}

// The /topics and /storylines Trending rule, on a page's daily counts, so
// the page says "▲ 3× a usual week" exactly when its row does.
export function riseOf(days, today) {
  const weekFrom = addDays(today, -(WEEK - 1))
  const baseFrom = addDays(weekFrom, -BASE_DAYS)
  let week = 0
  let base = 0
  for (const d of days) {
    if (d.day >= weekFrom && d.day <= today) week += d.total
    else if (d.day >= baseFrom && d.day < weekFrom) base += d.total
  }
  return risingLabel(week, (base / BASE_DAYS) * WEEK)
}
